module.exports = __webpack_public_path__ + "sy.6065fa16.svg";